import { useEffect } from 'react'
import { useHubBranding } from '../../hooks/useHubBranding'

export default function HubBrandingApplier() {
  const { branding } = useHubBranding()

  useEffect(() => {
    if (branding?.app_name) {
      document.title = branding.app_name
    }

    const href = branding?.favicon_url || branding?.logo_url
    if (!href) return

    let link = document.querySelector("link[rel='icon']")
    if (!link) {
      link = document.createElement('link')
      link.rel = 'icon'
      document.head.appendChild(link)
    }
    link.href = href
  }, [branding])

  return null
}
